<mat-expansion-panel *ngFor="let meldung of meldungen"
                     (opened)="panelOpenState = true" (closed)="panelOpenState =false">
  <mat-expansion-panel-header>
    <mat-panel-title class="stufen-panel-title">
              <span style="display: inline-block" *ngIf="meldung.ereignis.toLowerCase().includes('hitze')">
                <mat-icon class="summary-icon" matTooltip="Hitzewarnung" color="red">local_fire_department</mat-icon>
              </span>
      <span style="display: inline-block" *ngIf="meldung.ereignis.toLowerCase().includes('uv')">
                <mat-icon matTooltip="UV-Warnung" class="summary-icon" color="red">brightness_5</mat-icon>
              </span>
      <ng-container *ngIf="!isVorabInfo && meldung.stufe !== undefined">
        Unwetterwarnstufe: {{meldung.stufe}}
      </ng-container>
    </mat-panel-title>
    <mat-panel-description class="stufen-panel-description">
      {{meldung.ereignis}}
    </mat-panel-description>
  </mat-expansion-panel-header>
  <span class="warn-meldung-label">
            {{meldung?.ueberschrift}}: {{meldung?.text}}
          </span>
  <div class="warn-meldung-description">
        <span class="warn-meldung-gueltigkeit">
          Gültig ab {{meldung.gueltigAb | date: 'dd.MM.yyyy HH:mm'}}
          bis {{meldung.gueltigBis | date: 'dd.MM.yyyy HH:mm'}}
        </span>
  </div>
</mat-expansion-panel>
